import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Image } from 'expo-image';
import Svg, { Rect } from 'react-native-svg';
import Text from '@/components/Typography/Text';
import { SERIF } from './landingTokens';

const COAST = require('@/assets/images/landing-beach.webp');
const MOUNTAIN = require('@/assets/images/landing-mountain.webp');

/** Designed sample artifacts, without simulated playback or download controls. */
export default function LandingBotOutput({ kind, compact }) {
  const padding = compact ? 24 : 32;
  const height = compact ? 290 : 330;

  if (kind === 'writing') {
    return (
      <View style={{ minHeight: height, padding, backgroundColor: '#FCF9F2', justifyContent: 'space-between', gap: 22 }}>
        <Text weight="medium" style={{ color: '#88735C', fontSize: 10, letterSpacing: 1.7 }}>A STORY FOR THE SMALL HOURS</Text>
        <View style={{ gap: 18 }}>
          <Text style={{ color: '#3A3028', fontFamily: SERIF, fontSize: compact ? 30 : 37, lineHeight: compact ? 35 : 42, letterSpacing: -0.8 }}>The fox who{'\n'}borrowed the sky.</Text>
          <Text style={{ color: '#6F5F50', fontFamily: SERIF, fontSize: 16, lineHeight: 27 }}>Every night, a star fell into the garden. And every morning, Pip put it in his pocket.</Text>
          <Text style={{ color: '#6F5F50', fontFamily: SERIF, fontSize: 16, lineHeight: 27 }}>By Thursday, his coat was glowing. By Friday, the moon had noticed.</Text>
        </View>
        <Text style={{ color: '#88735C', fontSize: 10, letterSpacing: 1.1 }}>CHAPTER ONE / A POCKETFUL OF LIGHT</Text>
      </View>
    );
  }

  if (kind === 'game') {
    return (
      <View style={{ height, backgroundColor: '#121B2C', padding, justifyContent: 'space-between' }}>
        <View style={styles.spread}>
          <Text weight="semibold" style={{ color: '#E0EAF8', fontSize: 12, letterSpacing: 1.8 }}>STAR RUNNER</Text>
          <Text style={{ color: '#B6C4DE', fontSize: 10 }}>SCORE 0240</Text>
        </View>
        <View accessibilityRole="image" accessibilityLabel="Illustrative space game with a pixel spaceship, stars, and asteroids" style={{ flex: 1, marginVertical: 14 }}>
          <Svg width="100%" height="100%" viewBox="0 0 400 180" aria-hidden>
            {Array.from({ length: 24 }, (_, i) => <Rect key={i} x={(i * 137 + 9) % 394} y={(i * 53 + 12) % 174} width={i % 3 ? 2 : 3} height={i % 3 ? 2 : 3} fill={i % 3 ? '#7385A2' : '#D2D8EB'} />)}
            {[48, 140, 278, 343].map((x, i) => (
              <React.Fragment key={x}>
                <Rect x={x} y={16 + i % 2 * 36} width="20" height="20" fill="#B8A1CB" />
                <Rect x={x - 5} y={21 + i % 2 * 36} width="30" height="10" fill="#B8A1CB" />
                <Rect x={x + 5} y={21 + i % 2 * 36} width="5" height="5" fill="#75658E" />
              </React.Fragment>
            ))}
            <Rect x="197" y="92" width="6" height="12" fill="#F4D492" />
            <Rect x="197" y="118" width="6" height="30" fill="#F2F3F8" />
            <Rect x="191" y="130" width="18" height="24" fill="#F2F3F8" />
            <Rect x="179" y="142" width="42" height="12" fill="#A9C9E8" />
            <Rect x="197" y="136" width="6" height="12" fill="#638BB0" />
            <Rect x="191" y="160" width="6" height="12" fill="#E8AD75" />
            <Rect x="203" y="160" width="6" height="12" fill="#E8AD75" />
          </Svg>
        </View>
        <Text weight="medium" style={{ color: '#DBE4F2', fontSize: 16 }}>A small game. A whole new world.</Text>
      </View>
    );
  }

  const video = kind === 'video';
  return (
    <View style={{ height, backgroundColor: '#293E37', overflow: 'hidden' }}>
      <Image source={video ? COAST : MOUNTAIN} accessibilityLabel={video ? 'Golden light over a tropical coast in a sample film' : 'A mountain valley on a sample hiking club website'} contentFit="cover" style={StyleSheet.absoluteFillObject} />
      <View style={[StyleSheet.absoluteFillObject, { backgroundColor: video ? 'rgba(16,23,32,.38)' : 'rgba(8,25,18,.43)' }]} />
      <View style={{ flex: 1, padding, justifyContent: 'space-between', gap: 24 }}>
        <View style={styles.spread}>
          <Text weight="medium" style={{ color: '#FFFFFF', fontSize: 10, letterSpacing: 1.5 }}>{video ? 'GOLDEN HOUR' : 'THE WEEKEND TRAIL CLUB'}</Text>
          <Text style={{ color: '#FFFFFF', fontSize: 10 }}>{video ? 'A SHORT FILM' : 'EST. 2026'}</Text>
        </View>
        <View style={{ gap: 14 }}>
          <Text weight="semibold" style={{ color: '#FFFFFF', fontSize: compact ? 34 : 43, lineHeight: compact ? 38 : 47, letterSpacing: -1.4 }}>{video ? 'Chase the\nlast light.' : 'Less scrolling.\nMore wandering.'}</Text>
          <Text style={{ color: '#FFFFFF', fontSize: 12, lineHeight: 20 }}>{video ? 'Some days deserve a little longer.' : 'Find a trail. Bring a friend.'}</Text>
        </View>
        <View style={{ borderTopWidth: 1, borderTopColor: 'rgba(255,255,255,.35)', paddingTop: 14 }}>
          <Text style={{ color: '#FFFFFF', fontSize: 10, letterSpacing: 0.6 }}>{video ? 'SUMMER BY THE SEA / 00:30' : 'DAY HIKES / WEEKEND ADVENTURES / GOOD COMPANY'}</Text>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  spread: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', gap: 12 },
});
